import {
    STOCK_TAKING_CAR_MANAGEMENT_SAVE_FAST_STOCK_LOADING_DATA_BEGIN,
  } from '../constants';
  
  export function saveFastStockLoadingData(saveData) {
    return (dispatch) => {
      dispatch({
        type: STOCK_TAKING_CAR_MANAGEMENT_SAVE_FAST_STOCK_LOADING_DATA_BEGIN,
        data: {saveData}
      })
    }
  }